module.exports = __webpack_public_path__ + "img/banner.7e6f146e.png";